import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  //HStack, //Vishy 2025-02-18 build warning not used, so removed
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Link,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai"; //Vishy 2025-02-18 build warning "AiFillMail" not used, so removed
import { Icons } from "../../Assets/icons";
import aftrlogo from "../../Assets/images/AftrBlueLogo2048.png";
import logo from "../../Assets/images/logo-small.png";
import Header from "../../Components/Common/Header";

import Loader from "../../Components/Loader/Loader";
import { useNavigate, useParams } from "react-router-dom";
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import { errorHandler } from "../../Utils/handler";
import { AuthAPI } from "../../Apis/authAPI";

type Props = {};

const CreatePassword = (props: Props) => {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [loading, setLoading] = useState(false);

  const submitRef = useRef<any>(null);

  const navigate = useNavigate();

  const { success, error } = useToastWrapper();

  const [showPassword, setShowPassword] = useState({
    old: false,
    new: false,
  });

  const handleSubmit = async () => {
    if (!password || !confirmPassword)
      return error("Please fill all the fields", "");
    if (password !== confirmPassword)
      return error("Passwords do not match", "");
    try {
      setLoading(true);
      const res = await AuthAPI.createPassword(token, { password });
      if (res) {
        success("Password Updated Succcessfully! Kindly Login", "");
        if (res.data.role === "Admin") {
          navigate("/admin"); 
        } else {
          navigate("/"); 
        }
      }
    } catch (err) {
      error(errorHandler(err), "");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const listener = (event: any) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        submitRef.current.click();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  return (
    <Box height={"100%"} flexGrow={"grow"} p={6}>
      {loading ? <Loader /> : null}
      {/* Claude: added AFTR logo + footer logo to match Home/Login page style 20-02-2026 */}
      <Flex justifyContent="center" alignItems="center" mb={4}>
        <Image src={aftrlogo} alt="Aftr.Network" height="64px" objectFit="contain" bg="transparent" />
      </Flex>
      <Header>Create Password</Header>
      {/* <Text fontSize={"14px"} textAlign={"center"} mt={6}>
        Retrieve your password
      </Text> */}
      <Box mt={"32px"}>
        <FormControl>
          <FormLabel>Password</FormLabel>
          <InputGroup>
            <InputLeftElement h={"50px"} pointerEvents="none">
              <Image src={Icons.LoginMail} alt="" />
            </InputLeftElement>
            <Input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              h={"50px"}
              type={showPassword.old ? "text" : "password"}
              placeholder="Enter New Password"
            />
            <InputRightElement h={"50px"}>
              {showPassword.old ? (
                <AiFillEyeInvisible
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowPassword((prev) => ({
                      ...prev,
                      old: !prev.old,
                    }));
                  }}
                />
              ) : (
                <AiFillEye
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowPassword((prev) => ({
                      ...prev,
                      old: !prev.old,
                    }));
                  }}
                />
              )}
            </InputRightElement>
          </InputGroup>
        </FormControl>
        <FormControl mt={2}>
          <FormLabel>Confirm Password</FormLabel>
          <InputGroup>
            <InputLeftElement h={"50px"} pointerEvents="none">
              <Image src={Icons.LoginMail} alt="" />
            </InputLeftElement>
            <Input
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              h={"50px"}
              type={showPassword.new ? "text" : "password"}
              placeholder="Confirm New Password"
            />
            <InputRightElement h={"50px"}>
              {showPassword.new ? (
                <AiFillEyeInvisible
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowPassword((prev) => ({
                      ...prev,
                      new: !prev.new,
                    }));
                  }}
                />
              ) : (
                <AiFillEye
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowPassword((prev) => ({
                      ...prev,
                      new: !prev.new,
                    }));
                  }}
                />
              )}
            </InputRightElement>
          </InputGroup>
        </FormControl>
        <Flex justifyContent={"end"}>
          <Text
            onClick={() => {
              navigate(-1);
            }}
            color={"blue"}
            mt={2}
            cursor={"pointer"}
          >
            Back to Sign In
          </Text>
        </Flex>
      </Box>

      <Button
        ref={submitRef}
        onClick={handleSubmit}
        mt={"80px"}
        px={8}
        h={"60px"}
        alignItems={"center"}
        justifyContent={"center"}
        borderRadius={"16px"}
        display={"flex"}
        background={"primary.main"}
        color={"white"}
        _hover={{ background: "#2E7D32" }} // Claude: green hover, fit-to-text width 23-02-2026
      >
        Submit
      </Button>
      {/* <HStack mt={'34px'} justifyContent={'center'}>
                        <Text>
                        Don't have an account?
                        </Text>
                        <Text color={'#2869FE'}>
                        Sign Up
                        </Text>
                    </HStack> */}
      <Flex justifyContent="center" mt={8}>
        <Link href="https://after.network" isExternal>
          <Image src={logo} w={"100px"} />
        </Link>
      </Flex>
    </Box>
  );
};

export default CreatePassword;
